import { Directive, Input, TemplateRef } from '@angular/core';

import { generateUuid } from '@recruitee/utils';

import { SelectTemplatesService } from '../services/select-templates.service';

@Directive({
  standalone: true,
  selector: '[rtSelectHeaderTemplate]',
})
export class Select2HeaderTemplateDirective {
  private readonly uuid = generateUuid();

  @Input() public rtSelectHeaderTemplate: number;

  constructor(
    private templateRef: TemplateRef<void>,
    private selectTemplatesService: SelectTemplatesService,
  ) {}

  public ngOnInit() {
    this.selectTemplatesService.headerTemplateRegister({
      id: this.uuid,
      index: this.rtSelectHeaderTemplate,
      template: this.templateRef,
    });
  }

  public ngOnDestroy() {
    this.selectTemplatesService.headerTemplateRemove(this.uuid);
  }
}
